<template>
    <div class="multiselect-table">
        <div class="table-wrapper bg-white">
            <table class="table">
                <thead>
                    <tr class="border-b-2">
                        <th></th>
                        <th v-for="header in headerLabels" :key="header">{{ header }}</th>
                        <th style="width: 46px">
                            <button type="button" class="btn btn-primary" @click="onAddRowClick">
                                <PlusCircleIcon class="stroke-current" />
                            </button>
                        </th>
                    </tr>
                </thead>
                <draggable
                    tag="tbody"
                    :list="modelValue"
                    :disabled="false"
                    class="list-group"
                    handle=".handle"
                    item-key="name"
                >
                    <template #item="{ element, index }">
                        <tr>
                            <td class="w-0 border-b dark:border-dark-5">
                                <MenuIcon class="handle box-content p-2" />
                            </td>
                            <td class="border-b dark:border-dark-5">
                                <Multiselect
                                    v-model="element.id"
                                    :track-by="trackBy"
                                    :label="trackBy"
                                    value-prop="id"
                                    placeholder="Выберите элемент"
                                    :searchable="true"
                                    :options="options"
                                    @change="onOptionChanged"
                                    @open="onOpenMultiselect"
                                >
                                    <template #option="{ option }">
                                        <img
                                            v-if="showMoreDetailsInOptions && option.image?.url"
                                            :src="option.image.url"
                                            :alt="option.image.alt"
                                            class="multiselect-image"
                                        />
                                        <span v-if="showMoreDetailsInOptions" class="mr-3">{{ option.id }}</span>
                                        <span>{{ option[trackBy] }}</span>
                                        <div v-if="showMoreDetailsInOptions" class="multiselect-description">
                                            <div v-if="option.description" v-html="option.description"></div>
                                        </div>
                                    </template>
                                </Multiselect>
                            </td>
                            <td class="border-b dark:border-dark-5">
                                <button type="button" class="btn border-0 shadow-none" @click="onRemoveRowClick(index)">
                                    <XCircleIcon />
                                </button>
                            </td>
                        </tr>
                    </template>
                </draggable>
            </table>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import Multiselect from '@vueform/multiselect';

export default {
    name: 'MultiselectTable',
    components: { draggable, Multiselect },
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        draggable: Boolean,
        options: {
            type: Array,
            required: true,
        },
        trackBy: {
            type: String,
            default: 'title',
        },
        headerLabels: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        showMoreDetailsInOptions: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'remove', 'add'],
    data() {
        return {
            multiselectOptions: [],
        };
    },
    watch: {
        modelValue: {
            handler() {
                this.updateNonSelectedIndexes();
            },

            immediate: true,
        },
    },
    methods: {
        updateNonSelectedIndexes() {
            this.multiselectOptions = this.options.map((option) => {
                const t = this.modelValue.find((item) => item.id === option.id);

                option.disabled = !!t;

                return option;
            });
        },

        onRemoveRowClick(index) {
            const modelValue = this.modelValue.filter((_, i) => i !== index);
            this.$emit('update:modelValue', modelValue);
        },
        onAddRowClick() {
            const modelValue = [...this.modelValue, { id: null }];
            this.$emit('update:modelValue', modelValue);
        },

        onOptionChanged() {
            this.$nextTick(() => {
                this.updateNonSelectedIndexes();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .multiselect-dropdown {
        @apply max-h-[400px];
    }

    .multiselect-image {
        @apply w-[32px] h-[32px] max-h-[32px] max-w-[32px] min-h-[32px] min-w-[32px] mr-3;
    }

    .multiselect-description {
        @apply ml-3 max-w-[400px] text-xs truncate;
    }
}
</style>
